export default "__VITE_ASSET__cd5efc55__"